import {
  organizationSchema,
  buildBreadcrumbSchema,
  buildGraph,
  SITE_URL,
} from "../../shared/utils/seoSchemas";

export const reproductionSeo = {
  title: "Historical Reproduction | Palestine Pre-'48 Time Travel | Funooni",
  description:
    "Explore Funooni's historical reproduction project: restored archival photography, historical advertisements, and satirical caricatures from Palestine before 1948, tokenized and preserved on the blockchain.",
  keywords: [
    "historical reproduction",
    "Palestine archive",
    "pre-1948 Palestine",
    "archival photography",
    "Funooni",
    "NFT archive",
  ],
  canonicalUrl: `${SITE_URL}/reproduction`,
  robots: "index, follow",
  ogTitle: "Historical Reproduction | Funooni",
  ogDescription:
    "Palestine Pre-'48 Time Travel: restored archival photography and historical artifacts preserved on the blockchain.",
  ogImage: `${SITE_URL}/logo192.png`,
  ogUrl: `${SITE_URL}/reproduction`,
  ogType: "website",
  twitterCard: "",
  structuredData: buildGraph(
    organizationSchema,
    buildBreadcrumbSchema([
      { name: "Home", url: `${SITE_URL}/` },
      { name: "Historical Reproduction", url: `${SITE_URL}/reproduction` },
    ]),
    {
      "@type": "CollectionPage",
      name: "Historical Reproduction",
      description:
        "Palestine Pre-'48 Time Travel: restored archival photography, historical advertisements, and satirical caricatures preserved on the blockchain.",
      url: `${SITE_URL}/reproduction`,
    },
  ),
};
